import React from 'react';

import { block } from 'bem-cn';

import Typography from 'components/Typography';

import './tag.scss';

const b = block('tag');

const SIZES = {
  SMALL: 'small',
  NORMAL: 'normal',
  BIG: 'big',
};

type TagPropsType = {
  size?: (typeof SIZES)[keyof typeof SIZES];
  text: string;
  onClick?: () => void;
};

const TEXT_VARIANTS_BY_SIZE = {
  [SIZES.SMALL]: Typography.THEME.VARIANTS.TEXT_SMALL,
  [SIZES.NORMAL]: Typography.THEME.VARIANTS.TEXT_NORMAL,
  [SIZES.BIG]: Typography.THEME.VARIANTS.TEXT_BIG,
};

const Tag = ({ size = SIZES.SMALL, text, onClick }: TagPropsType) => (
  <div className={b({ [size]: true })} onClick={onClick}>
    <Typography
      component='div'
      className={b('tag-text')}
      variant={TEXT_VARIANTS_BY_SIZE[size]}
    >
      {text}
    </Typography>
  </div>
);

Tag.SIZE = SIZES;

export default Tag;
